import { render, staticRenderFns } from "./hotelBookingOrder.vue?vue&type=template&id=3c4d5356&scoped=true&"
import script from "./hotelBookingOrder.vue?vue&type=script&lang=js&"
export * from "./hotelBookingOrder.vue?vue&type=script&lang=js&"
import style0 from "./hotelBookingOrder.vue?vue&type=style&index=0&id=3c4d5356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d5356",
  null
  
)

export default component.exports